import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { ProjectCategoryRecord } from '#shared/cms/records'

type ProjectCategoryValue = Omit<ProjectCategoryRecord, '$type'>


export default /*@__PURE__*/_defineComponent({
  __name: 'new',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'New project category - admin - Daniel Roe' })

async function save (value: ProjectCategoryValue) {
  await $fetch('/api/admin/project-categories', { method: 'POST', body: value })
  await navigateTo('/admin/projects')
}

return (_ctx: any,_cache: any) => {
  const _component_AdminProjectCategoryForm = _resolveComponent("AdminProjectCategoryForm")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "New project category" }, {
    default: _withCtx(() => [
      _createVNode(_component_AdminProjectCategoryForm, {
        "submit-label": "Create",
        onSubmit: save
      })
    ]),
    _: 1
  }))
}
}

})